'use strict';
const href = require('./href.js');

/*
  Initial setup
  Create all neccessary router links
*/
function updateRouterLinks(Router) {
  let links = document.querySelectorAll('a');
  for (let i = 0; i < links.length; i += 1) {
    createRouterLink(Router, links[i]);
  }
}

/*
  Create router link
*/
function createRouterLink(Router, link) {

  // Don't need to update if already tagged
  if (link.getAttribute('data-router-link') !== null) return;

  if (link.classList.contains('no-router-link')) return;

  // Test fpr router link
  let Route = href.getRouteFromHref(Router.routes, link.getAttribute('href'));

  // If link is route, create router link
  if (Route) {
    link.setAttribute('data-router-link', '');
    link.addEventListener('click', function(event) {
      event.preventDefault();
      Router.navigateByRoute(Route, this.getAttribute('href'));
    }.bind(link));
  }
}

function setupRouterLinkUpdater(Router) {
  // Update links on childist change
  let observer = new MutationObserver(() => updateRouterLinks(Router));
  // Track all children changes
  let observerConfig = {
  	childList: true,
    subtree: true
  };
  observer.observe(document.body, observerConfig);
}


/*
  Automatically update router links
*/
function setupRouterLinks(Router) {
  updateRouterLinks(Router);
  setupRouterLinkUpdater(Router);
}

module.exports = {
  setupRouterLinks,
}



// WEBPACK FOOTER //
// ../autor/src/router-links.js